import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import MentorRoutes from "PlatForms/OrgLMS/Routes/MentorRoutes/MentorRoutes";
import { useSoftUIController } from "Common/hooks/context";
// import brand from 'src/assets/images/logo-ct.png'
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import MentorGroupDetail from "../../Admin/Internship/MentorGroupsList";
import AssignedGroupDetail from "../AssignedTrainings/AssignedGroupDetail";
import TrainingDetail from "../AssignedTrainings/trainingDetails";
import StatusReport from "../AssignedTrainings/StatusReport";

import ProgressReport from "../Projects/ProgressReport/ProgressReport";
import ProgressReportDetail from "../Projects/ProgressReport/ProgressReportDetail";
import IssueAndReport from "../AssignedTrainings/Issues&Challenges";
import { showSidebar } from "Common/Client/routeUtils";
import { getRoutes } from "Common/Client/routeUtils";
import AllFeedbacks from "../LandingPage/AllFeedbacks";
import AllLearners from "../LandingPage/AllLearners";
import CourseDetail from "../Library/CourseDetail";
import Register from "Common/Auth/SignUp";
import MentorProfileForm from "../MentorProfile/MentorProfile";
import AllTrainings from "../LandingPage/AllTrainings";
import TrainingMembers from "../LandingPage/TrainingMembers";

function MentorContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {layout === "dashboard" && showSidebar && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Mentor"
              routes={MentorRoutes}
            />
          </>
        )}
        <DashboardLayout>
          <DashboardNavbar />
          <Routes>
            {getRoutes(MentorRoutes)}
            <Route path="*" element={<Navigate to="/mentor-dashboard" />} />
            <Route path="/login" name="Login" element={<Login />} />
            <Route path="/register" name="Register" element={<Register />} />
            <Route
              path="/group-detail/:groupId"
              name="Group Detail"
              element={<MentorGroupDetail />}
            />
            <Route path="/assigned-group-detail/:id" element={<AssignedGroupDetail />} />
            <Route path="/view-training/:id" element={<TrainingDetail />} />
            <Route path="/status-report/:id" element={<StatusReport />} />
            <Route path="/progress-report" element={<ProgressReport />} />
            <Route path="/progress-report-detail/:id" element={<ProgressReportDetail />} />
            <Route path="/issues-and-report/:id" element={<IssueAndReport />} />
            <Route path="/all-feedback" element={<AllFeedbacks />} />
            <Route path="/mentor/all-learners" element={<AllLearners />} />
            <Route path="/mentor/all-trainings" element={<AllTrainings />} />
            <Route path="/mentor/learners-by-training" element={<TrainingMembers />} />
            <Route path="/course-detail/:id" element={<CourseDetail />} />
            <Route path="/mentor-profile" element={<MentorProfileForm />} />
          </Routes>
        </DashboardLayout>
      </ThemeProvider>
    </>
  );
}
export default MentorContent;
